import React from "react";
import { Modal } from "react-bootstrap";
import AIAgentSettingsPanel from "./AIAgentSettingsPanel";

// MainNav is a 260px fixed sidebar on desktop (z-index 1200). To make the
// dialog read as centred in the visible content area (i.e. ignoring the
// nav), we:
//   - lift the modal + backdrop above the nav so the backdrop dims the nav
//     and clicks on the nav close the dialog as expected;
//   - pad the modal element on the left by the nav width on desktop so the
//     dialog's `margin: auto` centres it inside `viewport - nav-width`.
const NAV_WIDTH = 260;
const NAV_Z = 1200;
const BACKDROP_Z = NAV_Z + 90;
const MODAL_Z = NAV_Z + 100;

export default function AIAgentSettingsModal({ show, onHide, onSaved }) {
  return (
    <>
      <style>{`
        .ai-agent-settings-modal-backdrop.modal-backdrop { z-index: ${BACKDROP_Z}; }
        @media (min-width: 768px) {
          .ai-agent-settings-modal.modal { padding-left: ${NAV_WIDTH}px; }
        }
      `}</style>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
        scrollable
        className="ai-agent-settings-modal"
        backdropClassName="ai-agent-settings-modal-backdrop"
        style={{ zIndex: MODAL_Z }}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 18, fontWeight: 700, color: "#111827" }}>
            AI Agent Settings
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "20px 24px" }}>
          {show && <AIAgentSettingsPanel onSaved={onSaved} />}
        </Modal.Body>
      </Modal>
    </>
  );
}
